import { render, staticRenderFns } from "./ChatAvatar.vue?vue&type=template&id=491e8436&scoped=true&"
import script from "./ChatAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChatAvatar.vue?vue&type=style&index=0&id=491e8436&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e8436",
  null
  
)

export default component.exports